import { useRef, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import { ModelOfStatus } from '../../database/index';

import api from '../../services/api';
import { AxiosResponse } from 'axios';

export const useFormCreateStatus = () => {
	const [loading, setLoading] = useState<boolean>(false);
	const [statusResponse, setStatusResponse] = useState<AxiosResponse | null>(null);
	const [statusEditedResponse, setStatusEditedResponse] = useState<AxiosResponse | null>(null);

	const history = useHistory();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const saveStatus = async (Status: ModelOfStatus) => {
		setLoading(true);

		const newStatus: ModelOfStatus = {
			...Status,
		};

		if (!!statusResponse) {
			api.put(`status/${statusResponse.data.ID}`, newStatus)
				.then((response) => {
					formik.resetForm();
					setStatusEditedResponse(response);
					setStatusResponse(null);
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Edição realizada',
						detail: 'O status foi editada com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Edição não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		} else {
			api.post('status', newStatus)
				.then((response) => {
					if (window.location.href === '/StatusForm') history.push('/listStatus');
					setLoading(false);
					setStatusResponse(response);
					setStatusEditedResponse(null);
					toast.current.show({
						severity: 'success',
						summary: 'Cadastro realizado',
						detail: 'Status cadastrado com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Cadastro não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		}
	};

	const formik = useFormik<ModelOfStatus>({
		initialValues: {
			DESCRICAO: '',
		},
		onSubmit: async (values) => await saveStatus(values),
		validationSchema,
	});

	return {
		getStatusFormController: {
			formik,
			loading,
			toast,
			statusResponse,
			statusEditedResponse,
		},
		handleStatusFormController: {
			setStatusResponse,
			setStatusEditedResponse,
		},
	};
};
